// extracted by mini-css-extract-plugin
export default {"card":"Error404_card__LJq5E","emojy":"Error404_emojy__lqXx0"};